import { motion } from "framer-motion";
import Image1 from "../assets/img-1.jpg";
import Image2 from "../assets/img-2.jpg";
import Image3 from "../assets/img-3.jpg";
import Image4 from "../assets/img-4.jpg";
import Image5 from "../assets/img-5.jpg";
import Image6 from "../assets/img-6.jpg";
import Image7 from "../assets/img-7.jpg";

const containerVariants = {
  offscreen: {},
  onscreen: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const WhatYoullLearn = () => {
  const cards = [
    {
      title: "BALANCE HORMONES NATURALLY",
      description:
        "Learn lifestyle and dietary tips to naturally regulate hormone levels and reduce PCOD symptoms.",
      image: Image1,
    },
    {
      title: "MANAGE IRREGULAR PERIODS",
      description:
        "Effective strategies to normalize menstrual cycles and improve reproductive health.",
      image: Image2,
    },
    {
      title: "LOSE WEIGHT HEALTHILY",
      description:
        "Discover safe exercise routines and nutrition plans to support weight loss for PCOD.",
      image: Image3,
    },
    {
      title: "BOOST FERTILITY",
      description:
        "Understand natural methods and supplements that can enhance fertility in PCOD patients.",
      image: Image4,
    },
    {
      title: "CONTROL ACNE & SKIN ISSUES",
      description:
        "Learn how to manage acne, oily skin, and other PCOD-related skin problems naturally.",
      image: Image5,
    },
    {
      title: "REDUCE STRESS & IMPROVE MOOD",
      description:
        "Simple daily practices like yoga, meditation, and diet changes to reduce stress and hormonal imbalance.",
      image: Image6,
    },
  ];

  const finalCard = {
    title: "REVEAL THE TRUTH ABOUT PCOD:",
    description:
      "Discover step-by-step solutions that doctors and healthcare professionals aren’t telling you about reversing PCOD.",
    image: Image7,
  };

  return (
    <section className="py-20 px-4 bg-pink-100 w-full mx-auto text-white lg:px-20 md:px-10">
      <h2 className="text-3xl md:text-5xl font-bold text-pink-600 text-center my-16">
        WHAT <span className="text-pink-600">YOU’LL LEARN</span>
      </h2>

      <motion.div
        className="grid md:grid-cols-2 gap-6"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: false, amount: 0.3 }}
        variants={containerVariants}
      >
        {cards.map((card, idx) => (
          <motion.div
            key={idx}
            whileHover={{ scale: 1.03 }}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="relative rounded-xl overflow-hidden h-56 flex flex-col justify-end p-6 cursor-pointer"
            style={{
              backgroundImage: `url(${card.image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute bg-black inset-0 opacity-50 rounded-xl"></div>

            <div className="relative z-10">
              <h3 className="text-lg md:text-xl font-bold mb-1">
                {card.title}
              </h3>
              <p className="text-sm md:text-base">{card.description}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>

      <motion.div className="py-6 flex items-center justify-center">
        <motion.div
          className="relative rounded-xl overflow-hidden h-56 flex flex-col justify-end p-6 cursor-pointer md:w-1/2"
          style={{
            backgroundImage: `url(${finalCard.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          transition={{ duration: 0.8, type: "spring", bounce: 0.2 }}
          viewport={{ once: false, amount: 0.3 }}
          whileHover={{ scale: 1.03 }}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
        >
          <div className="absolute inset-0 bg-black opacity-50 rounded-xl"></div>
          <div className="relative z-10">
            <h3 className="text-lg md:text-2xl font-bold mb-2">
              {finalCard.title}
            </h3>
            <p className="text-sm md:text-base">{finalCard.description}</p>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default WhatYoullLearn;
